let gridViewTotalCount = 20 ;
const partnerListTabs = ['your_plan_ott', 'All_ott_partners']
const partnersTabMap = {
    'your_plan_ott':'Your Plan OTT',
    'All_ott_partners':'All OTT Partners'
}
export {gridViewTotalCount,partnerListTabs,partnersTabMap} ;